var getStorage = function getStorage(key) {
  var storage = window.localStorage;
  var value = storage.getItem(key);
  if (value) {
    return JSON.parse(value);
  }
  return null;
};
var setStorage = function setStorage(key, data) {
  var storage = window.localStorage;
  try {
    storage.setItem("".concat(key), JSON.stringify(data));
  } catch (error) {
    console.error('===err===', error);
  }
};
var removeStorageItem = function removeStorageItem(key) {
  var storage = window.localStorage;
  storage.removeItem("".concat(key));
};
var clearStorage = function clearStorage() {
  var storage = window.localStorage;
  storage.clear();
};
export { getStorage, setStorage, removeStorageItem, clearStorage };